import React from 'react';

import { Form, Formik } from 'formik';

import { Button } from '@components/Button';
import ContactInformationAddress from '@presenters/web/pages/Profile/View/ContactInformation/ContactInformationAddress';
import ContactInformationEmail from '@presenters/web/pages/Profile/View/ContactInformation/ContactInformationEmail';
import ContactInformationPhone from '@presenters/web/pages/Profile/View/ContactInformation/ContactInformationPhone';

import {
  getCandidateDetailsPath,
  getDistrictMemberPath,
} from '@use-cases/leads';

import { useFetchAdminAccessRights } from '@repositories/clubs';

import { localizedNavigate } from '@utils/localized-navigate';

import { useTranslation } from '@external/react-i18next';

import { MemberDetailsQuery } from '@typings/operations';

export interface MemberDetailsProps {
  clubId: string;
  districtId: string;
  data: MemberDetailsQuery['addMemberGetIndividual']['individual'] | undefined;
}

const ConsolidateMemberRecord: React.FC<MemberDetailsProps> = ({
  clubId,
  districtId,
  data,
}) => {
  const { t } = useTranslation();

  const initialValues = {
    ...data,
  };

  const { data: clubData } = useFetchAdminAccessRights(clubId);
  const { clubName } = clubData?.club || {};

  const handleCancel = () => {
    districtId
      ? localizedNavigate(getDistrictMemberPath(districtId))
      : localizedNavigate(getCandidateDetailsPath(clubId));
  };

  return (
    <>
      <div className="mt-5 text-gray-600">
        <h2>
          {t(
            'mml.consolidate-member-record.title',
            'Consolidate member record'
          )}
        </h2>
      </div>
      <Formik initialValues={initialValues} onSubmit={() => {}}>
        {({ values }) => {
          return (
            <Form>
              <h3 className="mt-11 mb-0 font-normal text-lg text-black">
                {values.name}
              </h3>

              {values.primaryEmail && (
                <div className="mt-2">
                  <ContactInformationEmail email={values.primaryEmail} />
                </div>
              )}

              {values.primaryPhone && (
                <div>
                  <ContactInformationPhone
                    phone={values.primaryPhone}
                    phoneNumberColor="text-gray-600"
                  />
                </div>
              )}

              {values.primaryAddress && (
                <div className="mt-8">
                  <ContactInformationAddress
                    address={values.primaryAddress}
                    label={t(
                      'mml.consolidate-member-record.address',
                      'Address'
                    )}
                  />
                </div>
              )}

              <div className="mt-8">
                <h3 className="h5">
                  {t('mml.consolidate-member-record.member-id', 'Member ID')}
                </h3>
                {values.riIndividualId}
              </div>
              {districtId ? (
                <div className="mt-8">
                  <h3 className="h5">
                    {t('mml.consolidate-member-record.club', 'Club')}
                  </h3>
                  {clubName}
                </div>
              ) : (
                ''
              )}

              <div className="max-w-lg">
                <Button full className="mt-10 mb-6" clickHandler={() => {}}>
                  {t('mml.consolidate-member-record.submit', 'Submit')}
                </Button>
                <Button full text type="button" clickHandler={handleCancel}>
                  {t('mml.consolidate-member-record.cancel', 'Cancel')}
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default ConsolidateMemberRecord;
